/**
 * 관리자 권한
 */
export enum AdmAuth {
  Super = "superAdmin", // 슈퍼 관리자
  Admin = "admin", // 관리자
  Manager = "manager", // 매니저
  Coach = "coach", // 코치
}

/**
 * Yn 코드
 */
export enum Yn {
  /**
   * Y
   */
  Y = "Y",
  /**
   * N
   */
  N = "N",
}

/**
 * Yn 코드
 */
export enum QnaStat {
  /**
   * 미답변
   */
  Wait = "wait",
  /**
   * 답변 완료
   */
  Complete = "comp",
}
